import cn from "classnames"
import { isNaN } from "lodash"

// PEOPLE-ALIGN 2026-07-03 (Part 3): promoted from TeeUpsNd/Tabs/Item.tsx (Ale's .seg pill-tab
// treatment, coowe.html) to a shared location so People's segment pills (All | Contacts |
// CooWe-verse) render via the literal SAME component/CSS classes as the Inbox filter pills
// (Active | Invitations | Scheduled | Unscheduled | Archived), not a look-alike re-implementation.
// `TeeUpsNd/Tabs/Item.tsx` now re-exports this for zero-risk backward compatibility.
export interface SegPillProps {
  title: string
  active: boolean
  onClick: () => void
  paginationCount?: number | string
  testId?: string
}

const SegPill = ({
  title,
  active,
  paginationCount,
  onClick,
  testId,
}: SegPillProps) => {
  const isLoading = false

  return (
    <div
      data-testid={testId}
      className={cn(
        // Ale's .seg pill-tab treatment (coowe.html): rounded pills, active = dark ink pill,
        // quiet inactive (wave4-nav-ia fix5 -- state lives in the page header, not the rail)
        "flex gap-2 px-4 py-[6px] font-['Inter'] text-[13px] font-medium rounded-full cursor-pointer select-none box-border transition-all ease-in-out duration-300",
        {
          "bg-[#161A22] text-white": active,
          "text-[#586173] hover:bg-[#EFF3F9]": !active,
        }
      )}
      onClick={onClick}>
      <div>{title}</div>

      <div className="min-w-3">
        {!isLoading && !isNaN(paginationCount) && active && (
          <div>{paginationCount}</div>
        )}
      </div>
    </div>
  )
}

export default SegPill
